/**
 * Directive: detailListTemplate
 */
angular.module('acme.common.directive.detailListTemplate', [])
.directive('detailListTemplate', ['$compile', function($compile) {

    return {
      restrict: 'A',
      replace: true,
      require: 'ngModel',
      templateUrl: 'common/directives/detailListTemplate/detailListTemplate.tpl.html',

      link: function($scope, $element, $attrs, ngModelCtrl) {

        // Modified after controller runs
        ngModelCtrl.$formatters.push(function(modelValue) {
          if (modelValue.template) {
            var template = angular.element(modelValue.template.template);
            $element.append(template);
            $compile(template)(modelValue.template.getScope);
          }
        });

        ngModelCtrl.$parsers.push(function(viewValue) {
          return viewValue;
        });

      },

      controller: ['$scope', function($scope) {

        $scope.detailListTemplate = "Your spankin new detailListTemplate!";

      }]

    };

}]);